export enum PaymentMethodEnabled {
  PAYMENT_RMS_CREDIT_CARD_ENABLED = 'PAYMENT_RMS_CREDIT_CARD_ENABLED',
  PAYMENT_SQUARE_CREDIT_CARD_ENABLED = 'PAYMENT_SQUARE_CREDIT_CARD_ENABLED',
  PAYMENT_STRIPE_CREDIT_CARD_ENABLED = 'PAYMENT_STRIPE_CREDIT_CARD_ENABLED',
  PAYMENT_TRUSTPAYMENTS_CREDIT_CARD_ENABLED = 'PAYMENT_TRUSTPAYMENTS_CREDIT_CARD_ENABLED',
  PAYMENT_VIVA_CREDIT_CARD_ENABLED = 'PAYMENT_VIVA_CREDIT_CARD_ENABLED',
  PAYMENT_PAYABL_CREDIT_CARD_ENABLED = 'PAYMENT_PAYABL_CREDIT_CARD_ENABLED',
  PAYMENT_GLOBAL_PAY_CREDIT_CARD_ENABLED = 'PAYMENT_GLOBAL_PAY_CREDIT_CARD_ENABLED',
  PAYMENT_PAYMENTSENSE_CREDIT_CARD_ENABLED = 'PAYMENT_PAYMENTSENSE_CREDIT_CARD_ENABLED',
  PAYMENT_JCC_CREDIT_CARD_ENABLED = 'PAYMENT_JCC_CREDIT_CARD_ENABLED',
  PAYMENT_MOLLIE_CREDIT_CARD_ENABLED = 'PAYMENT_MOLLIE_CREDIT_CARD_ENABLED',
  PAYMENT_FYGARO_CREDIT_CARD_ENABLED = 'PAYMENT_FYGARO_CREDIT_CARD_ENABLED',
  PAYMENT_APCOPAY_CREDIT_CARD_ENABLED = 'PAYMENT_APCOPAY_CREDIT_CARD_ENABLED',
  PAYMENT_ABA_PAYWAY_CREDIT_CARD_ENABLED = 'PAYMENT_ABA_PAYWAY_CREDIT_CARD_ENABLED',
  PAYMENT_ROOTLINE_CREDIT_CARD_ENABLED = 'PAYMENT_ROOTLINE_CREDIT_CARD_ENABLED',
  PAYMENT_SOLIDGATE_CREDIT_CARD_ENABLED = 'PAYMENT_SOLIDGATE_CREDIT_CARD_ENABLED',
  PAYMENT_PAYPAL_ENABLED = 'PAYMENT_PAYPAL_ENABLED',
  POST_ORDER_PAYMENT_LINK_GENERAL_ENABLED = 'POST_ORDER_PAYMENT_LINK_GENERAL_ENABLED',
  POST_ORDER_PAYMENT_LINK_PAYPALME_ENABLED = 'POST_ORDER_PAYMENT_LINK_PAYPALME_ENABLED',
  PAYMENT_RYFT_ENABLED = 'PAYMENT_RYFT_ENABLED',
  PAYMENT_HOBEX_CREDIT_CARD_ENABLED = 'PAYMENT_HOBEX_CREDIT_CARD_ENABLED',
  PAYMENT_EPAY_CREDIT_CARD_ENABLED = 'PAYMENT_EPAY_CREDIT_CARD_ENABLED',
  PAYMENT_EMERCHANT_PAY_CREDIT_CARD_ENABLED = 'PAYMENT_EMERCHANT_PAY_CREDIT_CARD_ENABLED',
  PAYMENT_NEOSOFT_ENABLED = 'PAYMENT_NEOSOFT_ENABLED'
}

export const isAnyPaymentMethodEnabled = function(storeSettings: {key: string, value: PaymentMethodEnabled}) : boolean {
  if (storeSettings) {
    return Object.keys(PaymentMethodEnabled).some((paymentMethodEnabled: PaymentMethodEnabled) => {
      return isPaymentMethodEnabled(storeSettings, paymentMethodEnabled);
    });
  }
  return false;
}

export const isPaymentMethodEnabled = function(storeSettings: {key: string, value: string}, paymentMethodEnabled: PaymentMethodEnabled) : boolean {
  if (storeSettings) {
      return Object.prototype.hasOwnProperty.call(PaymentMethodEnabled, paymentMethodEnabled) && storeSettings[paymentMethodEnabled] === true;
  }
  return false;
}